import React, { useState } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import './Login.css';
import PasswordVisibilityIcon from './PasswordVisibilityIcon';

const ResetPassword = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!password || !confirmPassword) {
      setError('Please fill in both fields.');
      return;
    }
    if (password.length < 8) {
      setError('Password must be at least 8 characters.');
      return;
    }
    if (password !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }

    setError('');

    fetch('/reset-password', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token, password })
    })
      .then(res => res.json().then(data => ({ ok: res.ok, data })))
      .then(({ ok, data }) => {
        if (ok) {
          setSuccess(true);
          setTimeout(() => navigate('/login'), 3000);
        } else {
          setError(data.message);
        }
      })
      .catch(() => {
        setError('An error occurred. Please try again.');
      });
  };

  return (
    <div className="auth-container">
      <form className="auth-form" onSubmit={handleSubmit}>
        <div className="auth-header">
          <p>Account recovery</p>
          <h1>Set a new password</h1>
        </div>
        {error && <div className="error-message">{error}</div>}
        {success ? (
          <>
            <div className="success-message">
              Password has been reset. Redirecting to login...
            </div>
            <div className="login-prompt">
              <p>Not redirecting?</p>
              <Link to="/login" className="login-button">Go to login</Link>
            </div>
          </>
        ) : (
          <>
            <label>New password
              <div className="password-container">
                <input
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  required
                />
                <button
                  type="button"
                  className="toggle-password"
                  onClick={() => setShowPassword(!showPassword)}
                  aria-label={showPassword ? 'Hide password' : 'Show password'}
                >
                  <PasswordVisibilityIcon visible={showPassword} />
                </button>
              </div>
            </label>
            <label>Confirm password
              <div className="password-container">
                <input
                  type={showPassword ? 'text' : 'password'}
                  value={confirmPassword}
                  onChange={e => setConfirmPassword(e.target.value)}
                  required
                />
              </div>
            </label>
            <button type="submit">Reset password</button>
            <div className="login-prompt">
              <p>Remember your password?</p>
              <Link to="/login" className="login-button">Back to login</Link>
            </div>
          </>
        )}
      </form>
    </div>
  );
};

export default ResetPassword;
